import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import i18n from "i18next";
import { useEffect } from "react";

export const useLanguageURLParams = () => {
  const changeLanguage = (lng: Language) => {
    void i18n.changeLanguage(lng);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const languageParam = urlParams.get(URLParam.Language);

    // Set default only if param is not present
    let language = languageParam ? languageParam : getInitLanguage();

    if (language === "it-it" || language === "it-IT") language = Language.IT;
    if (language === "de-de" || language === "de-DE") language = Language.DE;
    if (language === "sl-si" || language === "sl-SI") language = Language.SL;
    if (language === "sr-rs" || language === "sr-RS") language = Language.SR;
    if (language === "cs-cz" || language === "cs-CZ") language = Language.CS;

    const isLanguageSupported = Object.values(Language).includes(language as Language);

    if (languageParam === null || !isLanguageSupported) {
      changeLanguage(language as Language);
      return;
    }
    if ((i18n?.language as Language) !== (language as Language)) {
      changeLanguage(language as Language);
    }
    // eslint-disable-next-line
  }, []);
};

export const getInitLanguage = (): Language => {
  let htmlElLanguage = document.documentElement?.lang;

  if (htmlElLanguage === "en-US" || htmlElLanguage === "en-GB") {
    htmlElLanguage = Language.EN;
  }

  if (htmlElLanguage === "it-it" || htmlElLanguage === "it-IT") htmlElLanguage = Language.IT;
  if (htmlElLanguage === "de-de" || htmlElLanguage === "de-DE") htmlElLanguage = Language.DE;
  if (htmlElLanguage === "sl-si" || htmlElLanguage === "sl-SI") htmlElLanguage = Language.SL;
  if (htmlElLanguage === "sr-rs" || htmlElLanguage === "sr-RS") htmlElLanguage = Language.SR;
  if (htmlElLanguage === "cs-cz" || htmlElLanguage === "cs-CZ") htmlElLanguage = Language.CS;

  return (htmlElLanguage as Language) || Language.EN;
};
